import { createContext } from 'react';

import { AriaIdsState, initialState } from '../ducks/reducer';

/** Context to store registered aria ids */
export const AriaIdsContext = createContext<AriaIdsState>(initialState);
